import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { color, radius, space, device, Text, fontWeight, BaseButton } from '@ticketswap/solar'
import SellerInformation from './SellerInformation'
import SecureSwapVideoDialog from '../SecureSwapVideoDialog'
import SecureSwapMark from '../SecureSwapMark'

const Item = styled.li`
  background-color: ${color.stardust};
  border-radius: ${radius.lg};
  padding: ${space[16]};

  @media ${device.tablet} {
    padding: ${space[24]};
  }

  &:not(:first-of-type) {
    margin-top: ${space[8]};

    @media ${device.tablet} {
      margin-top: ${space[16]};
    }
  }
`

const SecureSwapLogo = styled.span`
  position: relative;
`

const LogoType = styled(Text)`
  font-weight: ${fontWeight.semiBold};
  position: absolute;
  left: ${space[32]};
  white-space: nowrap;
`

const StyledText = styled(Text)`
  color: ${color.spaceMedium};
  padding-left: ${space[32]};
`

function Details({ t, listing }) {
  if (!listing.isSecureSwapAvailable && !Boolean(listing.seller)) {
    return null
  }

  return (
    <ul>
      {listing.isSecureSwapAvailable && (
        <Item>
          <SecureSwapLogo>
            <SecureSwapMark />
            <LogoType>SecureSwap</LogoType>
          </SecureSwapLogo>

          <SecureSwapVideoDialog t={t}>
            {({ getToggleProps }) => (
              <>
                <StyledText as="p">
                  {t('listing:purchaser.secureSwap')}{' '}
                  <BaseButton
                    {...getToggleProps()}
                    data-testid="secure-swap-button"
                    style={{ display: 'inline' }}
                  >
                    {t('common:generic.moreInfo')}
                  </BaseButton>
                </StyledText>
              </>
            )}
          </SecureSwapVideoDialog>
        </Item>
      )}

      {Boolean(listing.seller) && (
        <Item>
          <SellerInformation t={t} {...listing} />
        </Item>
      )}
    </ul>
  )
}

Details.propTypes = {
  t: PropTypes.func.isRequired,
  listing: PropTypes.shape({
    id: PropTypes.string,
    seller: PropTypes.object,
    isSecureSwapAvailable: PropTypes.bool,
  }),
}

export default Details
